<template>
    <li :class="getClassName">
        <span :class="{'clickable': hasMore}" @click="toggleShowMore">
            <strong class="me-2">
                <span class="air me-2">
                    <span v-if="hasMore" :class="{'fas fa-caret-right animate-300' : !show_more, 'fas fa-caret-right fa-smooth-rotate-90 animate-300' : show_more}"></span>
                </span>
                <span v-html="getElementName"></span>
            </strong>
            <small v-if="element.status_text" :class="getBadgeClassName">{{ element.status_text }}</small>
            <small v-if="element.planned" ><span class="font-italic">{{ $t('Planlagt') }} &mdash; {{ element.planned_formatted }}</span></small>
        </span>
        <div :class="{ 'animate-300 hidden-div': !show_more, 'animate-500 toggled-div': show_more }">
            <div v-if="getChildren.length > 0">
                <ul class="square-list">
                    <StandardListElement v-for="child in getChildren" :element="child" :key="child.element_id"></StandardListElement>
                </ul>
            </div>
            <div v-else-if="element.status_desc" class="rounded px-3 bg-light-gray py-3 shadow-subtle m-2">
                <div><span v-html="element.status_desc"></span></div>
            </div>
        </div>
    </li>
</template>

<script setup>
import { ref, computed } from 'vue';
import Store from "../../state/teachingCardStore";
import StandardListElement from './StandardListElement';

const props = defineProps(['element']);
const show_more = ref(false);

const getElementName = computed(() => {
    if (props.element.alias) {
        return props.element.alias;
    }
    return props.element.elem_name;
});

const getBadgeClassName = computed(() => {
    if (props.element.is_approved) {
        return 'badge bg-success';
    } else if (props.element.is_partly_approved) {
        return 'badge bg-primary bg-primary-darkest';
    } else if (props.element.is_in_progress) {
        return 'badge bg-secondary';
    }
    return '';
});

const getClassName = computed(() => {
    if (props.element.is_approved) {
        return 'success';
    } else if (props.element.is_partly_approved) {
        return 'partial-success';
    }
    return 'gray';
});

const getChildren = computed(() => {
    return props.element.children.filter(el => el.visible_in_ec);
});

const hasMore = computed(() => {
    return getChildren.value.length > 0 || props.element.status_desc;
});

function toggleShowMore() {
    show_more.value = !show_more.value;
}
</script>

<style scoped>

</style>